import { match } from "ts-pattern";

import type { PersonState } from "@thalamos/haven-common";

/** The tabs of a person's page, in the order they are shown. */
export const PERSON_TABS = [
  "assessments",
  "identity",
  "case-involvement",
] as const;

export type PersonTab = (typeof PERSON_TABS)[number];

/** The tab an address segment names, or `undefined` for one it does not. */
export const tabOf = (segment: string | undefined): PersonTab | undefined =>
  PERSON_TABS.find((tab) => tab === segment);

/**
 * The tab a person's page opens on when its address names none. `undefined` is a
 * state that could not be worked out, because the involvements did not load.
 */
export const openingTab = (state: PersonState | undefined): PersonTab =>
  state === undefined
    ? "assessments"
    : match(state.kind)
        .with("active", "archived", () => "assessments" as const)
        .with("unassigned", () => "case-involvement" as const)
        .exhaustive();
